export interface InitRequest {
  executionDateFrom: string,
  executionDateTo: string,
  executorList: [],
  executorId: string,
  searchSegment:number,
  stateList: [],
  creatingFlag: boolean,
  createCompleteFlag: boolean,
  creationErrorFlag: boolean
}


const initRequest : InitRequest = {
  executionDateFrom: '',
  executionDateTo: '',
  executorList: [],
  executorId: '',
  searchSegment: 0,
  stateList: [],
  creatingFlag: false,
  createCompleteFlag: false,
  creationErrorFlag: false,
}

const initErrorConfirm = {
  errorDivision: '',
  errorContent: '',
}

export {
  initRequest,
  initErrorConfirm
}